module.exports = __webpack_public_path__ + "images/marketing/peeps/dominik_staskiewicz.jpg";